import React from "react";
import styled from "styled-components";

interface Props {
  fullScreen?: boolean;
}

const Loader: React.FC<Props> = ({ fullScreen }) => {
  return (
    <LoaderContainer fullScreen={fullScreen}>
      <img src="https://media.tix.nl/loader_white_bg_48.gif" alt="Loader" />
    </LoaderContainer>
  );
};

const LoaderContainer = styled.div<{ fullScreen?: boolean }>`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`;

export default Loader;
